import React from "react";
import Reveal from "./Reveal";
import Window from "./Window";
import { VscTerminal } from "react-icons/vsc";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 flex items-center gap-1.5 text-xs text-syntax-comment">
      <span className="text-term-green">›</span>
      {label}
    </span>
    {children}
  </label>
);

const inputCls =
  "w-full rounded-md border border-editor-border bg-editor-inset px-3 py-2.5 text-sm text-zinc-200 caret-term-green placeholder-syntax-comment outline-none transition-colors focus:border-syntax-fn/60";

const Contact = () => {
  return (
    <section name="contact" className="relative w-full overflow-hidden py-24 md:py-28">
      <div className="animate-pulse-dot pointer-events-none absolute left-1/2 top-1/2 h-[24rem] w-[24rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-glow-purple blur-2xl" />

      <div className="relative mx-auto max-w-2xl px-4">
        <Reveal className="mb-8 text-center">
          <p className="kicker justify-center">
            <span className="text-syntax-comment">05 /</span>
            <span className="text-syntax-key">contact</span>
          </p>
          <h2 className="mt-3 text-2xl font-bold text-white sm:text-3xl">
            <span className="text-term-green">$</span> ./contact.sh
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-zinc-400">
            Have a role, a project, or just want to say hello? My inbox is always
            open — I'll reply as soon as I can.
          </p>
        </Reveal>

        <Reveal>
          <Window file="contact.sh" icon={<VscTerminal className="text-syntax-key" />}>
            <form
              action="https://getform.io/f/60567edb-6c65-483c-a5ff-4034040d946a"
              method="POST"
              className="space-y-4 p-6 sm:p-7"
            >
              <p className="text-xs text-syntax-comment">
                # fill in the fields below and hit send
              </p>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <Field label="name">
                  <input type="text" name="name" placeholder="your name" required className={inputCls} />
                </Field>
                <Field label="email">
                  <input type="email" name="email" placeholder="you@example.com" required className={inputCls} />
                </Field>
              </div>
              <Field label="message">
                <textarea name="message" rows="5" placeholder="tell me about it…" required className={inputCls} />
              </Field>
              <button
                type="submit"
                className="btn-cmd btn-cmd-primary w-full justify-center"
              >
                <span className="text-editor-bg/70">$</span> send --message
              </button>
            </form>
          </Window>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
